import React from "react";
import TaskList from "../../../interfaces/task/TaskList";
import { useNavigate } from "react-router-dom";
import Avatar from "../../../interfaces/avatar/Avatar";
import Pagination from "../../ui/Pagination/Pagination";
import tableattachmenticon from "../../../assets/images/tableattachmenticon.svg";
import signatureicon from "../../../assets/images/Signature.svg";
import avtar from "../../../assets/images/defaultavtarimg.svg";
import Colok from "../../../assets/images/PINKColok.svg";
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import { useAuth } from "../../../firebase/AuthProvider";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SkeletonRow from "../../ui/LoadingSkeleton/SkeletonRow";
import { FiClock } from "react-icons/fi";
import { PiFlagFill } from "react-icons/pi";
import NoDataFound from "../taskPage/NoDataFound";

interface TasksPageTableProps {
    tasks: TaskList[];
    avatars: Avatar[];
    displayTaskCount: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    isLoading: boolean;
    onPageChange?: (page: number) => void;
    setPage: (page: number) => void;
    setPageSize: (size: number) => void;
    handleSort?: (columnName: string) => void;
}

const Clock = FiClock as any;
const Flag = PiFlagFill as any;


const TasksPageTable: React.FC<TasksPageTableProps> = ({
    tasks,
    avatars,
    displayTaskCount = false,
    page,
    pageSize,
    totalCount,
    isLoading,
    onPageChange,
    setPage,
    setPageSize,
    handleSort,
}) => {
    const navigate = useNavigate();
    const { currentUser, currentOrganization, currentRoles } = useAuth();
    const userId = (currentUser as any)?.uid; // UID of the logged-in user
    const findAvatarById = (userId: string): string | null => {
        const avatarObj = avatars?.find((avatar) => avatar.id === userId);
        return avatarObj ? `data:image/png;base64,${avatarObj.avatar}` : null;
    };

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPageSize(pageSize);
        setPage(pageNumber);
    }

    const dueStyles: Record<string, { bg: string; icon: string }> = {
        late: {
            bg: "bg-[#FBD1D1]",
            icon: "text-red-600",
        },
        soon: {
            bg: "bg-[#FFF4CA]",
            icon: "text-yellow-600",
        },
        safe: {
            bg: "bg-[#D3FBD1]",
            icon: "text-green-600",
        },
    };


    const getDueStatus = (endDate?: string | Date) => {
        if (!endDate) return null;

        const today = new Date();
        const due = new Date(endDate);

        // Reset time for accurate day diff
        today.setHours(0, 0, 0, 0);
        due.setHours(0, 0, 0, 0);

        const diffInDays = Math.ceil(
            (due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
        );

        if (diffInDays < 0) {
            return "late"; // 🔴
        }

        if (diffInDays <= 3) {
            return "soon"; // 🟡
        }

        return "safe"; // 🟢
    };


    const isLate = (dueDate: Date): string => {
        try {
            // Get today's date and set the time to midnight for a fair comparison
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Get the due date and set its time to midnight
            const checkDate = new Date(dueDate);
            checkDate.setHours(0, 0, 0, 0);

            // Compare the dates to see if the due date is before today
            if (checkDate < today) {
                // If late, return the text color class
                return 'red-text'
            } else {
                return ''
            }
        } catch {
            return '';
        }
    };

    const STATUS_BADGE_COLORS: Record<string, string> = {
        "NOT STARTED": "#e8e8e8",
        "IN REVIEW (SUP)": "#FFC446",
        "IN REVIEW (PM)": "#FFC446",
        "COMPLETED": "#037010",
        "Pending Extension": "#BE68E0",
        "Extended": "#FF46E6",
        "READY_": "#5DC837",
        "ISSUES FOUND": "#FF5555",
        "CLOSED": "#898989",
        "Deleted": "#ACACAC",
        "IN PROGRESS": "#5DC837"
    };

    const badgeBaseClass =
        "text-[11px] capitalize text-black pt-1.5 pb-1 w-fit !px-3 flex items-center justify-center rounded-[6px] whitespace-nowrap";

    const typeBgMap = {
        Monthly: "bg-[#EA9CEB]",
        Quarterly: "bg-[#BFEFEA]",
        Annual: "bg-[#F6D6CC]",
        Interim: "bg-[#A9C7F5]",
    };


    return (
        <>
            <div className="overflow-x-auto w-full mt-2">
                <Table className="common_table min-w-[1100px]" style={{
                    tableLayout: 'fixed',
                    border: '#ffff',
                }}>
                    <thead>
                        <tr>
                            {/* <th>Title</th>
                        <th>Attachment</th>
                        <th>Participant</th>
                        <th>Type  <FontAwesomeIcon className="cursor-pointer" icon={faSort} onClick={() => handleSort?.("subtype")} /></th>
                        <th>Assignee</th>
                        <th >Due Date  <FontAwesomeIcon className="cursor-pointer" icon={faSort} onClick={() => handleSort?.("enddate")} /></th> */}
                            {/* <th>Proximity</th> */}
                            {/* <th }>Status  <FontAwesomeIcon className="cursor-pointer" icon={faSort} onClick={() => handleSort?.("status")} /></th> */}
                        </tr>
                    </thead>
                    <tbody
                        //     className="flex flex-col h-full xl:h-[calc(100vh-235px)] 2xl:h-[calc(100vh-290px)]
                        //  bg-red-200 overflow-y-hidden"
                        className={`flex flex-col h-full overflow-y-hidden ${pageSize === 10
                            ? 'page-size-10'
                            : ''
                            }`}
                    >
                        {isLoading ? (
                            [...Array(pageSize)].map((_, index) => <SkeletonRow key={index} columns={6} />)
                        ) : tasks?.length > 0 ? (
                            tasks.map((task, index) => {

                                const participantName =
                                    task.participant?.firstName || task.participant?.lastName
                                        ? `${task.participant.firstName ?? ""} ${task.participant.lastName ?? ""}`.trim()
                                        : "-";

                                const rawStatus = task.status?.name;

                                const displayStatus =
                                    rawStatus === "READY_" ? "In Progress" : rawStatus || "-";

                                const today = new Date();
                                const endDate = task.endDate ? new Date(task.endDate) : null;

                                let leftBorder = "transparent";

                                if (endDate) {
                                    const diffTime = endDate.getTime() - today.getTime();
                                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                    if (diffDays < 0) {
                                        // Late
                                        leftBorder = "#EF4444"; // red
                                    } else if (diffDays <= 5) {
                                        // Due within 5 days
                                        leftBorder = "#FACC15"; // yellow
                                    }
                                }

                                return <tr key={task.friendlyId || index}
                                    onClick={() => navigate(`/task/${currentOrganization?.abbreviation}-${task.friendlyId}`)}
                                    className="flex justify-between w-full my-1 rounded-lg height-10"
                                    style={{
                                        alignItems: "center",
                                        borderTop: "1px solid #C9C9C9",
                                        borderRight: "1px solid #C9C9C9",
                                        borderBottom: "1px solid #C9C9C9",
                                        borderLeft:
                                            leftBorder !== "transparent"
                                                ? `3px solid ${leftBorder}`
                                                : "1px solid #C9C9C9",
                                    }}
                                >
                                    <td className="w-[25%] py-2 px-3">
                                        <div className="w-full overflow-hidden">
                                            <div className="text-[11px] text-[#747474] truncate">
                                                {task.organization?.abbreviation}-{task.friendlyId}
                                                {" · "}
                                                {participantName}
                                            </div>
                                            <div className="mt-1 text-xs font-medium text-black line-clamp-2 leading-snug break-words" title={task.title}>
                                                {task.title}
                                            </div>
                                        </div>
                                    </td>
 

                                    {/* <td className="py-2 px-3 w-[11%]">
                                        <div className="flex items-center gap-2">
                                            {(() => {
                                                const status = getDueStatus(task.endDate);
                                                const styles = status ? dueStyles[status] : null;

                                                return (
                                                    <>
                                                        <div
                                                            className={`w-6 h-6 flex items-center justify-center rounded-full ${styles?.bg}`}
                                                        >
                                                            <Clock className={`text-[16px] text-[#000000]`} />
                                                        </div>

                                                        <span className="text-[#747474]">
                                                            {task.endDate
                                                                ? new Date(task.endDate).toLocaleDateString("en-US", {
                                                                    month: "short",
                                                                    day: "numeric",
                                                                    year: "numeric",
                                                                })
                                                                : "-"}
                                                        </span>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </td> */}

                                    <td className="py-2 px-3 w-[11%]">
                                        {(() => {
                                            if (!task.endDate) return <span className="text-[#747474]">-</span>;

                                            const status = getDueStatus(task.endDate);

                                            const today = new Date().getTime();
                                            const endDate = new Date(task.endDate).getTime();

                                            const diffTime = endDate - today;
                                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                            const isLate = diffDays < 0;

                                            return (
                                                <div className="flex flex-col items-center justify-center text-center leading-tight">
                                                    <span className="text-[#747474] text-xs">
                                                        {isLate
                                                            ? `Late: ${Math.abs(diffDays)} days`
                                                            : `Due: ${diffDays} days`}
                                                    </span>
                                                </div>
                                            );
                                        })()}
                                    </td>



                                    <td className="py-2 px-3 w-[20%]">
                                        <div className="flex gap-2 items-center w-[100%]">
                                            {/* Sub Type Badge */}
                                            <div className="w-[40%]">
                                                <span className={`w-full ${badgeBaseClass} 
                                                ${task.subType?.type === "MONTHLY" ? "bg-[#EA9CEB]" : task.subType?.type === "QUARTERLY" ? "bg-[#C1F1F1]" : task.subType?.type === "INTERIM" ? "bg-[#9CC1EB]" : "bg-[#F6DDD8]"}
                                                `}>
                                                    {task.subType?.type || "Monthly"}
                                                </span>
                                            </div>

                                            {/* Status Badge */}
                                            <div className="w-[60%]">
                                                <span
                                                    style={{ justifyContent: "center" }}
                                                    className={`uppercase ${badgeBaseClass} bg-[#F4F4F4] text-black w-full m-0 flex items-center gap-2 px-2 py-1 rounded-md`}
                                                >
                                                    {/* Flag */}
                                                    <span className="flex items-center justify-center w-4 h-6">
                                                        <Flag
                                                            className="w-4 h-4"
                                                            style={{
                                                                fill: STATUS_BADGE_COLORS[task.status?.name] || "#9ca3af",
                                                            }}
                                                        />
                                                    </span>

                                                    {/* Status text */}
                                                    {displayStatus}
                                                </span>
                                            </div>

                                        </div>
                                    </td>

                                    {/* <td className="w-[22%]">
                                        <div className="flex items-center gap-2.5 w-full">
                                            <img
                                                src={task.assignees?.find(a => a.isReporter)?.user?.avatar || avtar}
                                                alt="User Avatar"
                                                className="w-9 h-9 rounded-full object-cover"
                                            />
                                            <div className="flex flex-col">
                                                <span className=" capitalize text-[#747474]">
                                                    {task.assignees?.find(a => a.isReporter)?.user?.displayName || "-"}
                                                </span>
                                            </div>

                                        </div>
                                    </td> */}

                                    <td className="w-[17%]">
                                        <div className="flex items-center gap-2.5 w-full">
                                            {(() => {
                                                const assignees = task.assignees.filter(a => !a.isReporter);
                                                const lastAssignee = assignees[assignees.length - 1];

                                                if (!lastAssignee) return null;

                                                const user = lastAssignee.user;
                                                const avatarUrl = user.avatar;

                                                return (
                                                    <div className="flex items-center gap-2.5 w-full">
                                                        <img
                                                            src={avatarUrl || avtar}
                                                            alt={`${user.firstName} ${user.lastName}`}
                                                            className="w-7 h-7 rounded-full object-cover"
                                                        />
                                                        <div className="flex flex-col">
                                                            <span className="capitalize text-[#747474] text-xs">
                                                                {user.firstName} {user.lastName}
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    </td>



                                    {/* <td className="w-[22%]">
                                        {currentRoles?.length !== 1 && userId === currentUser?.uid ? (
                                            <>
                                                {task.assignees.some((assignee) => {
                                                    // Normal assignee (not reporter, not co-assignee)
                                                    if (!assignee.isReporter && !assignee.isCoAssignee) {
                                                        return assignee.user.id === currentUser?.uid;
                                                    }
                                                    // Co-assignee
                                                    if (!assignee.isReporter && assignee.isCoAssignee) {
                                                        return assignee.user.id === currentUser?.uid;
                                                    }
                                                    return false;
                                                }) ? (
                                                    // ✅ User matches → render assignees
                                                    <div className="flex items-center gap-2.5 w-full">
                                                        <img
                                                            src={task.assignees?.find(a => a.isReporter)?.user?.avatar || avtar}
                                                            alt="User Avatar"
                                                            className="w-9 h-9 rounded-full object-cover"
                                                        />

                                                        <div className="flex flex-col">
                                                            <span className="capitalize text-[#747474]">
                                                                {task.assignees?.find(a => a.isReporter)?.user?.displayName || "-"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    // ❌ User not allowed → show required asterisk
                                                    <div className="text-red-500 text-center">*</div>
                                                )}
                                            </>
                                        ) : (
                                            // If role count = 1 or userId != current user → normal render
                                            <div className="flex items-center gap-2.5 w-full">
                                                pp
                                            </div>
                                        )}
                                    </td> */}


                                    {/* {currentRoles?.length !== 1 && userId === currentUser?.uid && (
                                        <>
                                            {task.assignees.some((assignee) => {
                                                if (!assignee.isReporter && !assignee.isCoAssignee) {
                                                    return assignee.user.id === currentUser?.uid;
                                                } else if (!assignee.isReporter && assignee.isCoAssignee) {
                                                    return assignee.user.id === currentUser?.uid;
                                                }
                                                return false;
                                            }) ? (
                                                // ✅ USER IS ASSIGNED → RENDER REPORTER INFO (your old UI)
                                                <td className="w-[22%]">
                                                    <div className="flex items-center gap-2.5 w-full">
                                                        <img
                                                            src={
                                                                task.assignees?.find(a => a.isReporter)?.user?.avatar || avtar
                                                            }
                                                            alt="User Avatar"
                                                            className="w-9 h-9 rounded-full object-cover"
                                                        />
                                                        <div className="flex flex-col">
                                                            <span className="capitalize text-[#747474]">
                                                                {task.assignees?.find(a => a.isReporter)?.user?.displayName || "-"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                            ) : (
                                                // ❌ USER NOT ASSIGNED → SHOW RED STAR (*)
                                                <td className="w-[22%]">
                                                    <div className="text-red-500 text-center">*</div>
                                                </td>
                                            )}
                                        </>
                                    )} */}


                                    <td className="text-[#747474] !text-[12px] w-[12%]">
                                        {(() => {
                                            if (!task?.lastActivityDate) return "-";

                                            const lastActivity = new Date(task.lastActivityDate);
                                            const now = new Date();

                                            const diffTime = now.getTime() - lastActivity.getTime();
                                            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                                            if (diffDays <= 0) {
                                                return "Last activity : Today";
                                            }

                                            return `Last activity : ${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
                                        })()}
                                    </td>


                                    <td className="w-[13%] flex gap-x-2 justify-end">

                                        {/* Attachment */}
                                        {task.attachmentCount > 0 && (
                                            <div className="flex items-center gap-2">
                                                <div className="relative flex items-center">
                                                    <div className="w-7 h-7 bg-[#F9F6FF] -rotate-45 rounded-full p-1 flex items-center justify-center">
                                                        <img
                                                            src={tableattachmenticon}
                                                            alt="attachment"
                                                            className="w-[17px] h-[17px]"
                                                        />
                                                    </div>
                                                    <span className="ml-2 text-sm font-medium text-[#333]">
                                                        {task.attachmentCount}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Signature */}
                                        {task.pendingSignatureCount > 0 && (
                                            <div className="flex items-center gap-2">
                                                <div className="relative flex items-center">
                                                    <div className="w-7 h-7 bg-[#F9F6FF] rounded-full p-1 flex items-center justify-center">
                                                        <img
                                                            src={signatureicon}
                                                            alt="signature"
                                                            className="w-[16px] h-[16px]"
                                                        />
                                                    </div>
                                                    <span className="ml-2 text-sm font-medium text-[#333]">
                                                        {task.pendingSignatureCount}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                    </td>



                                    {/* <td title={task.title} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    <span className="highlight_txt">{task.title}</span>
                                </td>

                                <td>
                                    {task.participant
                                        ? `${task.participant.firstName?.charAt(0)}. ${task.participant.lastName}`
                                        : "-"}
                                </td>

                                <td>{task.subType.type || task.subType.type || "-"}</td>

                                <td>
                                    <div className="stack_img_flx">
                                        {task.assignees?.length > 0 ? (
                                            task.assignees.map((ass, i) => {
                                                if (ass.isReporter) return; // We don't want to show the reporter of the task

                                                return (
                                                    <div className="stack_img" key={i} title={ass.user.displayName}>
                                                        {ass.user.avatar ? (
                                                            <img
                                                                className="stack_img "
                                                                src={ass.user.avatar || avtar}
                                                                alt={ass.user.displayName}
                                                                onError={(e) => {
                                                                    const target = e.target as HTMLImageElement;
                                                                    target.onerror = null;
                                                                    target.src = avtar;
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="stack_img_txt">
                                                                {ass.user?.firstName[0] + ass.user?.lastName[0]}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            "-"
                                        )}
                                    </div>

                                </td>

                                <td className={`${isLate(task.endDate)}`}>
                                    {task.endDate
                                        ? new Date(task.endDate).toLocaleDateString("en-US")
                                        : "-"}
                                </td>

                                <td>
                                    <Badge bg="danger">{task.priority || "-"}</Badge>
                                </td>

                                <td>
                                    <Badge
                                        className={`${task.status.name === 'READY' && 'text-black'}`}
                                        bg={
                                            task.status?.name === "COMPLETED"
                                                ? "success"
                                                : task.status?.name === "IN REVIEW (PM)"
                                                    ? "warning"
                                                    : task.status?.name === "IN REVIEW (SUP)"
                                                        ? "warning"
                                                        : task.status?.name === "READY"
                                                            ? "light"
                                                            : task.status?.name === 'CLOSED' || task.status?.name.toLowerCase().includes('issues')
                                                                ? "danger"
                                                                : "secondary"
                                        }
                                    >
                                        {task.status.name || "-"}
                                    </Badge>
                                </td> */}
                                </tr>;
                            })
                        ) : (
                            <NoDataFound
                                title="No Task Found"
                                description="There is no task to show you right now"
                            />
                        )}
                    </tbody>
                </Table>
            </div>

            {onPageChange ? (<>
                {totalCount > 0 && <Pagination
                    currentPage={page}
                    totalPages={Math.ceil(totalCount / pageSize) || 0}
                    onPageChange={onPageChange}
                    pageSize={pageSize}
                    resetPageSize={resetPageSize}
                />}
            </>
            ) : (
                <div className="text-muted mx-auto text-end pe-8 pb-3 pt-0 text-sm w-full">
                    {"Page: " + page} |{" "}
                    {totalCount + " total tasks"}
                </div>
            )}
        </>
    );
};

export default TasksPageTable;
